import { render } from "./FacetPanelKeyword.vue?vue&type=template&id=297d809a&scoped=true&ts=true"
import script from "./FacetPanelKeyword.vue?vue&type=script&lang=ts"
export * from "./FacetPanelKeyword.vue?vue&type=script&lang=ts"

import "./FacetPanelKeyword.vue?vue&type=style&index=0&id=297d809a&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src245414373/src/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-297d809a"]])

export default __exports__